export const ModalStyles = {
  underlay: { cursor: "default", backgroundColor: "rgba(0,0,0,0.7)" }
};
